import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  TextField,
  Typography,
} from '@mui/material';

export interface TranslationField {
  key: string;
  label: string;
  multiline?: boolean;
  rows?: number;
}

export interface TranslationValues {
  fr: Record<string, string>;
  es: Record<string, string>;
}

interface TranslationTabsProps {
  fields: TranslationField[];
  values: TranslationValues;
  onChange: (values: TranslationValues) => void;
}

const LANGUAGES = [
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
] as const;

const TranslationTabs: React.FC<TranslationTabsProps> = ({ fields, values, onChange }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleFieldChange = (lang: 'fr' | 'es', key: string, value: string) => {
    onChange({
      ...values,
      [lang]: {
        ...values[lang],
        [key]: value,
      },
    });
  };

  const activeLang = LANGUAGES[activeTab].code;

  return (
    <Box sx={{ mt: 2, border: 1, borderColor: 'divider', borderRadius: 1, p: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Traductions
      </Typography>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        {LANGUAGES.map((lang) => (
          <Tab key={lang.code} label={lang.label} />
        ))}
      </Tabs>

      {fields.map((field) => (
        <TextField
          key={field.key}
          fullWidth
          label={field.label}
          value={values[activeLang]?.[field.key] || ''}
          onChange={(e) => handleFieldChange(activeLang, field.key, e.target.value)}
          multiline={field.multiline}
          rows={field.multiline ? (field.rows || 3) : undefined}
          margin="dense"
          size="small"
          placeholder={`${field.label} en ${LANGUAGES[activeTab].label}`}
        />
      ))}
    </Box>
  );
};

export default TranslationTabs;
